import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * A custom element that allows the user to select a quantity.
 *
 * @typedef {Object} Refs
 * @property {HTMLInputElement} quantityInput
 *
 * @extends {Component<Refs>}
 */
class QuantitySelectorComponent extends Component {
  /**
   * Handles the quantity increase event.
   * @param {Event} event - The event.
   */
  increaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    this.refs.quantityInput.stepUp();
    this.#onQuantityChange();
  }

  /**
   * Handles the quantity decrease event.
   * @param {Event} event - The event.
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    this.refs.quantityInput.stepDown();
    this.#onQuantityChange();
  }

  /**
   * When our input gets focused, we want to fully select the value.
   * @param {FocusEvent} event
   */
  selectInputValue(event) {
    const { quantityInput } = this.refs;
    if (!(event.target instanceof HTMLInputElement) || document.activeElement !== quantityInput) return;

    quantityInput.select();
  }

  /**
   * Handles the quantity set event.
   * @param {Event} event - The event.
   */
  setQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    if (event.target instanceof HTMLInputElement) {
      this.refs.quantityInput.value = event.target.value;
    }
    this.#onQuantityChange();
  }

  /**
   * Handles the quantity change event.
   */
  #onQuantityChange() {
    const { quantityInput } = this.refs;

    this.#checkQuantityRules();
    const newValue = parseInt(quantityInput.value);

    quantityInput.dispatchEvent(new QuantitySelectorUpdateEvent(newValue, Number(quantityInput.dataset.cartLine)));
  }

  /**
   * Checks the quantity rules are met
   */
  #checkQuantityRules = () => {
    const { quantityInput } = this.refs;
    const { min, max, value: newValue } = quantityInput;

    if (newValue < min && min) quantityInput.value = min;
    if (newValue > max && max) quantityInput.value = max;
  };

  /**
   * Gets the quantity input.
   * @returns {HTMLInputElement} The quantity input.
   */
  get quantityInput() {
    if (!this.refs.quantityInput) {
      throw new Error('Missing <input ref="quantityInput" /> inside <quantity-selector-component />');
    }

    return this.refs.quantityInput;
  }
}

if (!customElements.get('quantity-selector-component')) {
  customElements.define('quantity-selector-component', QuantitySelectorComponent);
}



//  custom js to initially remove the checked from all input.
document.addEventListener("DOMContentLoaded", function () {
  let cstm_input = document.querySelectorAll(".cstm_variant_input");
  let cstm_select = document.querySelectorAll(".cstm_select_size");
    let cstm_sizmsg = document.querySelectorAll(".oversize");
  let cstm_add = document.querySelectorAll(".cstm_add_to_cart");
  let cstm_form = document.querySelector(".cstm_prdct_form");
  let cstm_quantity = null;

  cstm_input.forEach((item) => {
    item.checked = false;
  });

  if (cstm_form) {
    cstm_quantity = cstm_form.querySelector(".cstm_quantity_selector");
    if (cstm_quantity) {
      cstm_quantity.classList.add("cstm_evnt");
    }
  }

  cstm_input.forEach((item) => {
    item.addEventListener("click", () => {
      // NOTE: The size options are a single native radio group (all inputs share the same
      // `name`), so clicking one already unchecks the rest and checks the clicked value.
      // The previous logic here assumed TWO duplicate size groups (old desktop+mobile PDP)
      // and mirror-checked index i AND i+length/2 — on the current single group of 6 that
      // meant clicking XS (0) also re-checked L (3), and L won. Removed the manual re-check
      // so the browser's native selection stands; only the UX side-effects run below.

      cstm_select.forEach((selected) => {
        selected.style.display = "none";
      });
      cstm_add.forEach((adding) => {
        adding.style.display = "block";
      });

      if (cstm_quantity) cstm_quantity.classList.remove("cstm_evnt");
      cstm_sizmsg.forEach((sizee)=>{
   sizee.style.display = "block";
})
    });
  });
});

//-----cstm preorder code starts------//
document.querySelectorAll(".cstm_variant_input").forEach((item) => {
  let preorderInput = document.querySelector('input[name="properties[Type]"]');
  let addToCartForm = document.querySelector('form[action="/cart/add"]');
  const eligible_for_preorder = item.getAttribute('eligible_for_preorder');
  if (eligible_for_preorder) {
    const preText = document.querySelector(".cstm_pre_text");
    if (preText) preText.style.display = "block";
  }
  // item.addEventListener("click", () => {
  //   if (eligible_for_preorder) {
  //     if (!preorderInput) {
  //       const input = document.createElement("input");
  //       input.type = "hidden";
  //       input.name = "properties[Type]";
  //       input.value = "Cstm Preorder";
  //       addToCartForm.appendChild(input);
  //     }
  //   }
  //   else {
  //     if (preorderInput) preorderInput.remove();
  //   }
  // });
});
//-----cstm preorder code ends------//